import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const SpaceIcon = (props: SvgProps) => <Svg
  width='24'
  height='24'
  viewBox='0 0 24 24'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M11.4804 2V11.5634L3 16.4338V6.78032L11.4804 2ZM21 16.4338L12.5196 11.5634V2L21 6.78032V16.4338ZM3.60125 17.2657L12 12.4421L20.3987 17.2657L12 22L3.60125 17.2657Z'
    fill={props.color ?? 'white'}
  />
</Svg>;

export default SpaceIcon;
